define('setup/setup',['require','lodash','knockout','plugins/router','./setup-configurator','./save-test-variations','i18next','api-access','durandal/app','recruit-modal/recruit-modal'],function (require) {
    var _ = require('lodash');
    var ko = require('knockout');
    var router = require('plugins/router');
    var setupConfigurator = require('./setup-configurator');
    var saveTestVariations = require('./save-test-variations');
    var i18n = require('i18next');
    var userApi = require('api-access').user;
    var app = require('durandal/app');
    var recruitModal = require('recruit-modal/recruit-modal');

    var baseRouterConfig = {
        'reserve-g2mm': {
            route: 'setup/reserve-g2mm',
            moduleId: 'setup/reserve-g2mm/reserve-g2mm',
            title: i18n.t('setup.common.setUpTitle')
        },
        'default-numbers': {
            route: 'setup/default-numbers',
            moduleId: 'setup/default-numbers/default-numbers',
            title: i18n.t('setup.common.setUpTitle')
        },
        'admin-audio': {
            route: 'setup/admin-audio',
            moduleId: 'setup/admin-audio/admin-audio',
            title: i18n.t('setup.common.setUpTitle')
        },
        'free-trial': {
            route: 'setup/free-trial',
            moduleId: 'setup/free-trial/free-trial',
            title: i18n.t('setup.common.setUpTitle')
        }
    };

    // return the router configuration for the given user
    // only exposing the pages that are available to that
    // type of user
    var getRouterConfig = function (setupConfig) {
        return _.values(_.pick(baseRouterConfig, function (config, key) {
            return _.has(setupConfig, key);
        })).map(function (config) {
            var pageKey = config.route.replace('setup/', '');

            return _.extend({}, config, {
                currentStep: setupConfig[pageKey].currentStep
            });
        });
    };

    return function () {
        var self = this;

        self.markOnboardingViewed = function () {
            app.trigger('setup:viewed');
            userApi.updateSettings({onboardingViewed: true});
        };

        var setupInitialization = saveTestVariations().then(function () {
            return setupConfigurator.initialize()
                .then(function () {
                    // no matter what page we are looking at
                    // we should mark the global onboardingViewed flag to true
                    self.markOnboardingViewed();

                    // Create the routing only after the setup configurator is initialized.
                    // That way we can grab the initial page value and only expose the routes
                    // that are available for the given configuration
                    var setupConfig = setupConfigurator.getSetupData();

                    // some times we could end up with no steps to go to in setup...
                    // (ie. voip users when g2mm is down)
                    // in that case we send him back to the meetings page
                    if (!setupConfig.totalSteps) {
                        return router.navigate('/');
                    }

                    var routerConfig = getRouterConfig(setupConfig);
                    self.router = router.createChildRouter()
                        .map(routerConfig)
                        .mapUnknownRoutes(function (instruction) {
                            instruction.config = _.findWhere(self.router.routes, {route: setupConfig.initialPage});
                        });

                    self.header = ko.computed(function () {
                        if (self.router.activeInstruction()) {
                            var routerConfigResponse = self.router.activeInstruction().config;
                            return {
                                model: 'setup/header/header',
                                activationData: {
                                    currentStep: routerConfigResponse.currentStep,
                                    totalSteps: setupConfig.totalSteps,
                                    isFreeTrialUser: setupConfig['free-trial'],
                                    isG2MMSchedulingTest: setupConfig.isG2MMSchedulingTest
                                }
                            };
                        }
                        return undefined;
                    });
                    return undefined;
                });
        });

        self.activate = function () {
            return setupInitialization;
        };

        self.detached = function () {
            recruitModal.show();
        };
    };
});

